import { BubbleMenu, Editor } from "@tiptap/react";
import {
  Sparkles
} from "lucide-react";
import { memo, useState } from "react";
import { AIEditorPanel } from "../../panels/AIEditorPanel/AIEditorPanel.js";
import { ColorPicker } from "../../panels/index.js";
import { Icon } from "../../ui/Icon.js";
import { Toolbar } from "../../ui/Toolbar.js";
import { ContentTypePicker } from "./components/ContentTypePicker.js";
// import { FontFamilyPicker } from "./components/FontFamilyPicker.js";
import i18next from "i18next";
import { FontSizePicker } from "./components/FontSizePicker.js";
import { useTextmenuCommands } from "./hooks/useTextmenuCommands.js";
import { useTextmenuContentTypes } from "./hooks/useTextmenuContentTypes.js";
import { useTextmenuStates } from "./hooks/useTextmenuStates.js";


export type TextMenuProps = {
  editor: Editor;
  dir: "rtl" | "ltr" | "auto";
};

export const AITextMenu = ({ editor, dir }: TextMenuProps) => {
  const commands = useTextmenuCommands(editor);
  const states = useTextmenuStates(editor);
  const blockOptions = useTextmenuContentTypes(editor);
  const [openAi, setOpenAi] = useState(false);

  return (
    <BubbleMenu
      tippyOptions={{
        placement: "auto",
        popperOptions: {
          placement: "auto",
        },
        onHide: () => {
          setOpenAi(false);
        },
      }}
      editor={editor}
      pluginKey="textMenu"
      shouldShow={states.shouldShow}
      updateDelay={100}
    >
      {openAi ? (
        <AIEditorPanel
          editor={editor}
          onOpenChange={(value) => {
            setOpenAi(value);
          }}
        />
      ) : (
        <Toolbar.Wrapper>
          <Toolbar.Button
            className="text-purple-500 hover:text-purple-600 active:text-purple-600 dark:text-purple-400 dark:hover:text-purple-300 dark:active:text-purple-400"
            activeClassname="text-purple-600 hover:text-purple-600 dark:text-purple-400 dark:hover:text-purple-200"
            onClick={() => setOpenAi(true)}
          >
            <Icon icon={Sparkles} className="mr-1" />
            {i18next.t("aiTools") || "AI Tools"}
            <span className="text-xs ml-1 px-2 py-1 bg-purple-100 text-purple-700 rounded-full dark:bg-purple-700 dark:text-purple-100 align-baseline">
              Beta
            </span>
          </Toolbar.Button>
        </Toolbar.Wrapper>
      )}
    </BubbleMenu>
  );
};
